
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import ArbeitsplaetzeDetail from '@/components/Arbeitsplaetze/ArbeitsplaetzeDetail.vue';
    import Arbeitsplatz from '@/types/Arbeitsplatz';
    import { DataTableHeaders, DataTableHeaderType } from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        components: {
            ArbeitsplaetzeDetail,
        },
        computed: {
            ...mapState('arbeitsplaetze', ['arbeitsplaetze', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('arbeitsplaetze', ['loadArbeitsplaetze']),
            ...mapMutations('arbeitsplaetze', ['setDialogsDetail']),
        },
    })
    export default class Arbeitsplaetze extends Vue {
        public arbeitsplatz = new Arbeitsplatz();
        public search = '';

        public loadArbeitsplaetze!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Arbeitsplatz> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Arbeitsplatz', value: 'arbeitsplatz' },
                { text: 'Aufrufanzeige', value: 'aufrufanzeige' },
                { text: 'Kartenlesegerät', value: 'cardreader_id_patient' },
                { text: 'Standarddrucker', value: 'standarddrucker' },
                { text: 'Etikettendrucker', value: 'etikettendrucker' },
                this.getSystemEinstellung('rezeptdrucker').isEnabled()
                    ? { text: 'Rezeptdrucker', value: 'rezeptdrucker' } as DataTableHeaderType<Arbeitsplatz>
                    : null,
                /*{ text: 'Impfstelle', value: 'impfstelle_bezeichnung' },*/
            ].filter((header) => header) as DataTableHeaders<Arbeitsplatz>;
        }

        public mounted(): void {
            this.loadArbeitsplaetze();
        }

        public onClickEdit(arbeitsplatz: Arbeitsplatz): void {
            this.arbeitsplatz = new Arbeitsplatz(arbeitsplatz);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.arbeitsplatz = new Arbeitsplatz();
            this.setDialogsDetail(true);
        }
    }
